import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface TowBarProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function TowBar(props: TowBarProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Tow Bar"
      width={26}
      height={18}
      viewBox="0 0 26 18"
      position={{top: 242, right: -24}}
    >
      <path
        d="M17 17.001C21.4183 17.001 25 13.4183 25 9C24.9997 4.58195 21.4181 1 17 1C13.5398 1 10.5929 3.19743 9.47754 6.27246L1 4V14L9.39355 11.4824C10.438 14.6856 13.4482 17.001 17 17.001Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}), 'cursor-pointer')}
      />
      <circle
        cx="17"
        cy="9.00049"
        r="8"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M1 4.00049L9 6.00049V12.0005L1 14.0005V4.00049Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
